import { Component, Input, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatRadioModule } from "@angular/material/radio";
import { TranslateModule } from "@ngx-translate/core";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";

enum AnswerOption{
	KEEP = "keepMiddleline",
	LEFT = "left",
	RIGHT = "right",
	OPPOSITE_JAW = "adjustToJaw"
}

@Component({
	selector: "middleline-form",
	standalone: true,
	imports: [
		CommonModule,
		MatRadioModule,
		MatFormFieldModule,
		MatInputModule,
		TranslateModule,
		ReactiveFormsModule],
	templateUrl: "./middlelineForm.component.html",
	styleUrl: "./middlelineForm.component.scss"
})
export class MiddlelineFormComponent implements OnInit {
	@Input() parentForm: FormGroup;
	@Input() isUpperJaw: boolean;
	@Input() nestedFormGroupName: string;

	AnswerOption = AnswerOption;

	jawFormControlName: string;
	optionFormControl: FormControl;
	textFormControl: FormControl;

	ngOnInit(): void {
		this.jawFormControlName = this.isUpperJaw ? 'uj' : 'lj';

		this.optionFormControl = this.parentForm.get(`${this.nestedFormGroupName}.${this.jawFormControlName}.option`) as FormControl;
		this.textFormControl = this.parentForm.get(`${this.nestedFormGroupName}.${this.jawFormControlName}.text`) as FormControl;

		//set en-/disabled state depending on value (e.g. should not be disabled when form is prefilled)
		if(this.textFormControl.value){
			this.textFormControl.enable({emitEvent: false});
		}else{
			this.textFormControl.disable({emitEvent: false});
		}

		this.optionFormControl?.valueChanges.subscribe((value) => {
			if(value === AnswerOption.LEFT || value === AnswerOption.RIGHT  ){
				this.textFormControl?.enable({emitEvent: false});
				this.textFormControl?.setValidators([Validators.required])
				this.textFormControl.markAsTouched();
			} else {
				this.textFormControl?.patchValue(null, { emitEvent: false });
				this.textFormControl?.disable({emitEvent: false});
				this.textFormControl?.clearValidators();
			}
			this.textFormControl?.updateValueAndValidity();
		});
	}
}
